import React, { PureComponent } from "react"
import PropTypes from "prop-types"

const interaction = ({ i, aid, filter = null }) => {
  if (filter && !filter()) {
    return
  }

  if (!!i && !!aid && window.miBaby && window.miBaby.app.ct) {
    miBaby.app.ct.interaction({
      i,
      aid,
    })
  }
}

const answer = ({ id }) => {
  if (!!id && window.miBaby && window.miBaby.app.ct) {
    const method = "ANSWER"
    miBaby.app.ct.answer({
      id,
    })
  }
}

export const trackRaw = (type, data) => {
  ;({
    interaction: interaction,
    answer: answer,
  }[type](data))
}

const ClickTracker = ({
  method = "interaction",
  id,
  name,
  aid,
  filter,
  tag = "div",
  ...props
}) => {
  const handleClick = ev => {
    switch (method) {
      case "interaction":
        interaction({ i: name, aid, filter: filter && (() => filter(ev)) })
        break
      case "answer":
        answer({ id })
        break
    }
  }

  return React.createElement(tag, { onClick: handleClick, ...props })
}

export default ClickTracker
